import styled, { CSSObject } from 'styled-components';
import type { BoxStyledProps } from './Box.typed';

const checkIsValue = <T,>(value: T | null | undefined): value is T => {
  return typeof value !== 'undefined' || value !== null;
};
const cleanValue = (value: string | number): string | number => {
  if (typeof value === 'number' && value !== 0) {
    return `${value}px`;
  }
  return value;
};

export const Box = styled.div<BoxStyledProps>((props) => {
  const {
    position,
    top,
    left,
    right,
    bottom,
    center,
    centerX,
    centerY,
    width,
    height,
  } = props;
  return {
    position: typeof position === 'undefined' ? 'static' : position,
    ...(checkIsValue(top) ? { top: cleanValue(top) } : {}),
    ...(checkIsValue(right) ? { right: cleanValue(right) } : {}),
    ...(checkIsValue(bottom) ? { bottom: cleanValue(bottom) } : {}),
    ...(checkIsValue(left) ? { left: cleanValue(left) } : {}),
    display: 'block',
    // verticalAlign is a bit of hack, need to figure out a better approach
    verticalAlign: 'top',
    ...(center ? ({ transform: 'translate(-50%, -50%)' } as CSSObject) : {}),
    ...(centerX ? ({ transform: 'translate(-50%, 0)' } as CSSObject) : {}),
    ...(centerY ? ({ transform: 'translate(0, -50%)' } as CSSObject) : {}),
    ...(checkIsValue(width) ? { width: cleanValue(width) } : {}),
    ...(checkIsValue(height) ? { height: cleanValue(height) } : {}),
  };
});
